class SessionStorage {
  static saveAdmin(admin) {
    sessionStorage.setItem('admin', JSON.stringify(admin));
  }

  static getAdmin() {
    return JSON.parse(sessionStorage.getItem('admin'));
  }

  static saveUser(user) {
    sessionStorage.setItem('user', JSON.stringify(user));
  }

  static getUser() {
    return JSON.parse(sessionStorage.getItem('user'));
  }

  static saveStopTime(time) {
    sessionStorage.setItem('localStopTime', time);
  }

  static getStopTime() {
    return sessionStorage.getItem('localStopTime');
  }

  static removeStopTime() {
    return sessionStorage.removeItem('localStopTime');
  }

  static saveRoom(room) {
    sessionStorage.setItem('room', JSON.stringify(room));
  }

  static getRoom() {
    return JSON.parse(sessionStorage.getItem('room'));
  }

  static saveLoggedUser(logged) {
    sessionStorage.setItem('loggedUser', JSON.stringify(logged));
  }

  static getLoggedUser() {
    return JSON.parse(sessionStorage.getItem('loggedUser'));
  }

  static saveUserLoggedOut(userLoggedOut) {
    sessionStorage.setItem('hasUserLoggedOut', JSON.stringify(userLoggedOut));
  }

  static getUserLoggedOut() {
    return JSON.parse(sessionStorage.getItem('hasUserLoggedOut'));
  }

  static clearStorage() {
    sessionStorage.clear();
  }
}

export default SessionStorage;
